import { computed, signal, Service } from '@angular/core';
import { DEFAULT_LANGUAGE, directionOf, Language, TextDirection } from '@core/i18n/domain/language';

/**
 * LanguageStore — pure signal state for the active language + derived
 * direction. No I/O. The shell host binds `[attr.dir]`/`[attr.lang]` to these,
 * so a language change re-flows the whole v2 surface (RTL ⇄ LTR) reactively.
 */
@Service()
export class LanguageStore {
  private readonly _lang = signal<Language>(DEFAULT_LANGUAGE);

  readonly current = computed(() => this._lang());
  readonly direction = computed<TextDirection>(() => directionOf(this._lang()));
  readonly isRtl = computed(() => this.direction() === 'rtl');

  set(lang: Language): void {
    this._lang.set(lang);
  }
}
